// One codebase, two restaurants. The name and logo were hardcoded as
// "Frita Delivery" in six pages and imported directly in three, which is why a
// Sanata build still called itself Frita once React took over the document
// title. Both brands' assets were already in this repo.
import fritaLogo from "./assets/svg/frita-logo.png";
import sanataLogo from "./assets/svg/sanata-logo.png";

export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Frita Delivery";
export const BRAND_LOGO =
  process.env.REACT_APP_BRAND_LOGO === "sanata" ? sanataLogo : fritaLogo;
